export default "__VITE_ASSET__CURZCPIP__"